
/* injects from baggage-loader */

'use strict';

import DialogAlertController from '../alert/alert.controller';

export default class DialogSelectMonkeyController extends DialogAlertController {
    constructor($log, $rootScope) {
        'ngInject';

        super($log, $rootScope);
    }

    submit(response){
        if(!response || response < 1) return false;
        this.resolve.model.selected_monkey = response;
        this.ok();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/select-monkey/select-monkey.controller.js